module.exports = __webpack_public_path__ + "img/xiaochengxu_3.bb8de931.png";